import { render, staticRenderFns } from "./paideslips.vue?vue&type=template&id=7d8e3e2e"
import script from "./paideslips.vue?vue&type=script&lang=js"
export * from "./paideslips.vue?vue&type=script&lang=js"
import style0 from "./paideslips.vue?vue&type=style&index=0&id=7d8e3e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports